export default {
  dialogStack: [],
  allowEscapeToClose: true
}
